import { StepStatus } from '../../common/types/Stepper';
import { createSlice } from "@reduxjs/toolkit";
// import { data, totalCount } from '../containers/CardData/CardDataTabs/DummyData';

const tabTrackRequestProcess = createSlice({
    name: 'process',
    initialState: {
        statusCreated: StepStatus.PENDING,statusEvaluted: StepStatus.PENDING, statusLang: StepStatus.PENDING,
        statusModerated: StepStatus.PENDING,statusPublished: StepStatus.PENDING,progressCountPublisher: 0,
        progressCountModerator: 0,progressCountEvaluator: 0,progressCountLangEval: 0,progressCountCreator: 0,
        hideProgressModerator: false,hideProgressEval: false,hideProgressLang: false
    },
    reducer: {
        countZero: ( state, action ) => {
            console.log('countZero');
            const { payload } = action;
            return { ...state, ...payload }
            // state.statusCreated = StepStatus.PENDING;
            // state.statusEvaluted = StepStatus.PENDING;
            // state.statusLang = StepStatus.PENDING;
            // state.statusModerated = StepStatus.PENDING;
            // state.statusPublished = StepStatus.PENDING;
        },

        setActiveCreated: ( state ) => {
            // let tempCreate = 0;
            // for( let i=0; i<data.length; i++) {
            //     if( data[i].status.creator.isJobCompleted) {
            //         state.progressCountCreator += 1;
            //         tempCreate++;
            //     }
            // }
            // console.log('COUNTER', state.progressCountCreator);
            // if( data.length === 0 ) {
            //     state.statusCreated = StepStatus.PENDING;
            // }
            // else {
            //     (tempCreate === totalCount)? state.statusCreated = StepStatus.DONE :
            //     state.statusCreated = StepStatus.INPROGRESS; 
            // }
        },
        setActiveEvaluated: ( state, action ) => {

        },
        setActiveLang: ( state, action ) => {

        },
        setActiveModerated: ( state, action ) => {

        },
        setActivePublished: ( state, action ) => {

        }
    }
})

const { actions, reducer } = tabTrackRequestProcess;

export default reducer;
export const contentRequestActions = actions;